import React from "react";
import Nav from "./Nav";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const Header = () => {
  return (
    <MainHeader>
      <NavLink to="/">
        <img src="./image/logo.png" alt="mylogo" className="logo" />
      </NavLink>
      <Nav />
    </MainHeader>
  );
};

const MainHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.bg};
  height: 6rem;
  padding: 0 4rem;
  display: flex;
  justify-content: space-between;
  align-item: center;
  .logo {
    height: 6rem;
  }
`;
export default Header;
